import { Component, inject, Input } from '@angular/core';
import { ApplicationStatusEnum, BriefStatusProgressDto } from '../../../../../common/general-types/briefs.dto';
import { FormatService } from '../../../../../common/format/format.service';

@Component({
  selector: 'brief-feed-auto-pilot-off',
  standalone: true,
  imports: [],
  templateUrl: './feed-auto-pilot-off.component.html',
  styleUrl: './feed-auto-pilot-off.component.css'
})
export class FeedAutoPilotOffComponent {

  @Input('activity') activity!: {
    applicationStatus: ApplicationStatusEnum;
    briefStatusProgress: BriefStatusProgressDto;
    date: Date;
  }

  /** Services */
  public formatService = inject(FormatService);
  /** Services END */
}
